module.exports = __webpack_public_path__ + "c6bbc170f085fb8a5b96db0dd4dde77a.png";